import { isSubCategoryMandatory } from 'partner360/entities/planning'

import type { IFinancialPlanQualityData } from '../model/types'

interface ISobSetting {
  ProgramType: string
  Category: string
  SubCategory: string
  IsMainHierarchy: number
  SOBMandatoryByFlags?: string
}

export interface ISobMandatoryContext {
  partnerFlags: string
  sectionSettings: Parameters<typeof isSubCategoryMandatory>[2]
}

export const applySobMandatorySettings = (
  rows: IFinancialPlanQualityData[],
  settings: ISobSetting[],
  context: ISobMandatoryContext,
  offering?: string
): IFinancialPlanQualityData[] =>
  rows.map((row) => {
    const categorySettings = settings.filter(
      (setting) =>
        setting.IsMainHierarchy === 1 &&
        setting.ProgramType.trim() === (offering ?? row.offering ?? '').trim() &&
        setting.Category.trim() === row.category.trim()
    )
    const isMandatory = (setting: ISobSetting) =>
      isSubCategoryMandatory(
        context.partnerFlags,
        setting.SOBMandatoryByFlags ?? '',
        context.sectionSettings,
        false
      ).isMandatory

    return {
      ...row,
      isSobMandatory: categorySettings.some(isMandatory),
      children: row.children?.map((child) => ({
        ...child,
        isSobMandatory: categorySettings
          .filter((setting) => setting.SubCategory.trim() === child.category.trim())
          .some(isMandatory),
      })),
    }
  })
